import { readEnv, readEnvFlag } from 'app-core'

export const ENV = {
  get API_ENV() {
    return readEnv('REACT_APP_API_ENV') ?? 'PROD'
  },
  get API_URL() {
    return readEnv('REACT_APP_SERVER')
  },
  get API_TOKEN() {
    return readEnv('REACT_APP_API_TOKEN')
  },
  get NAV_ID() {
    return readEnv('REACT_APP_NAV_ID')
  },
  get DEBUG() {
    return readEnvFlag('REACT_APP_DEBUG')
  },
  get SHOW_ONLY_PUBLISHED() {
    return readEnvFlag('REACT_APP_SHOW_ONLY_PUBLISHED')
  },
  get PACKAGE_VERSION() {
    return readEnv('PACKAGE_VERSION') ?? '0.0.0'
  },
  get SENTRY_ENABLED() {
    return readEnvFlag('REACT_APP_SENTRY_ENABLED')
  },
  get SENTRY_DSN() {
    return readEnv('REACT_APP_SENTRY_DSN')
  },
} as const
